import React, { Fragment } from "react"
import styled from "styled-components"

import { buildSlug } from "~/utilities/string"
import Item from "./Item"

const Container = styled.div`
  display: flex;
  flex-direction: column;
`

const HR = styled.hr`
  border: none;
  height: 1px;
  background-color: ${props => props.theme.colors.ui.inputBorder};
  padding: 0;
  margin: 0;
`

const Accordion = ({ items, open }) => {
  return (
    <Container>
      {items.map((item, index) => {
        const slug = buildSlug(item[0])
        return (
          <Fragment key={item[0]}>
            <Item
              slug={slug}
              title={item[0]}
              text={item[1]}
              open={open === slug}
            />
            {index !== items.length - 1 ? <HR /> : null}
          </Fragment>
        )
      })}
    </Container>
  )
}

export default Accordion
